import React, { useState } from 'react';
import { Modal, Carousel } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SamplereactCroper from './samplereactCroper';

function CarouselSlider({ show, cropRef, toggle, files, cropSize, getCropedFile, index, isVertical }) {
  const [currentIndex, setCurrentIndex] = useState();
  const [cropedFiles, setCropedFiles] = useState([]);
  const { t } = useTranslation('common');

  const handleSelect = (e) => {
    if (e <= files.length) {
      setCurrentIndex(e++);
    } else {
      setCurrentIndex(e--);
    }
  };

  const getCropeByindex = async (obj) => {
    if (obj.imageRes !== undefined) {
      if (obj.imageRes === 'data:,') {
        return setCropedFiles([]);
      }
      if (!cropedFiles.length) {
        setCropedFiles((objdata) => [...objdata, obj]);
      } else if (cropedFiles.find((ele) => ele.index === obj.index)) {
        const str = [...cropedFiles];
        const objIndex = str.findIndex((ele) => ele.index === obj.index);
        str[objIndex].imageRes = obj.imageRes;
        setCropedFiles([...str]);
      } else {
        setCropedFiles((objdata) => [...objdata, obj]);
      }
    }
  };
  const toBase64 = async (file) =>
    new Promise((resolve, reject) => {
      // Handle base64 strings directly
      if (typeof file === 'string' && file.startsWith('data:')) {
        resolve(file);
        return;
      }

      // Handle File/Blob objects
      if (file instanceof File || file instanceof Blob) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        return;
      }

      // Fallback for other types
      reject(new Error('Invalid file type for base64 conversion'));
    });

  const saveCroper = async () => {
    cropedFiles.map((ele) => {
      files[ele.index].cropedImage = ele.imageRes;
    });
    for (const row of files) {
      // Check if preview is already a base64 string
      if (row.preview && typeof row.preview === 'string' && row.preview.startsWith('data:')) {
        // Already base64, no conversion needed
        continue;
      }

      // Check if preview is a blob URL or if we need to convert the file object
      if (row.preview && typeof row.preview === 'string' && row.preview.startsWith('blob:')) {
        // Convert blob URL to base64
        try {
          const response = await fetch(row.preview);
          const blob = await response.blob();
          const base64 = await toBase64(blob);
          row.preview = base64;
        } catch (error) {
          console.error('Failed to convert blob to base64:', error);
        }
      } else if (row instanceof File || row instanceof Blob) {
        // Convert File/Blob object to base64
        try {
          const base64 = await toBase64(row);
          row.preview = base64;
        } catch (error) {
          console.error('Failed to convert file to base64:', error);
        }
      }
    }
    getCropedFile([...files]);
    toggle();
  };
  return (
    <Modal
      className="custom-modal supplier-overview-modal"
      style={{ minHeight: '100vh', background: 'gray' }}
      size="xl"
      fullscreen
      show={show}
      onHide={toggle}
      backdrop="static"
      centered
    >
      <Modal.Header>
        <Modal.Title>{t('CAROUSEL_SLIDER.CROP_IMAGES')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Carousel controls={files.length !== 1} interval={null} activeIndex={currentIndex || index} onSelect={handleSelect}>
          {files.map((file, i) => (
            <Carousel.Item
              onChange={() => {
                setCurrentIndex(i);
              }}
              key={`${file?.name}_${i}`}
            >
              <div className="d-flex justify-content-center">
                <SamplereactCroper
                  ref={cropRef}
                  cropSize="4/3"
                  key={file.name}
                  index={currentIndex || index}
                  style={{ verticalAlign: 'bottom' }}
                  src={file.preview}
                  getCropeByindex={getCropeByindex}
                  isVertical={isVertical}
                />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-buttons mt-5 d-flex justify-content-between w-100">
          <button type="button" onClick={toggle} className="btn btn-default">
            {t('CAROUSEL_SLIDER.CLOSE')}
          </button>
          <button type="button" onClick={saveCroper} className="btn btn-default">
            {t('CAROUSEL_SLIDER.SAVE')}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CarouselSlider;
